<div class="header">
  <div class="left">
    <h2>Logs for API Key: {{keyId}}</h2>
  </div>
    <div class="right">
        <ol class="breadcrumb">
            <li>
                <span [routerLink]="['/Dashboard']" routerLinkActive="router-link-active">Home</span>
            </li>
            <li>
                <span [routerLink]="['/dev-console']" routerLinkActive="router-link-active">Developer Console</span>
            </li>
            <li>
                <span [routerLink]="['/view-logs']" routerLinkActive="router-link-active" class="disabled">View Logs</span>
            </li>
        </ol>
    </div>
</div>
<custom-table
   [tableData]="keyLogs"
   [tableColumns]="displayedColumns"
    hideTableTitle="true"
></custom-table>
